import UploadLocation from './UploadLocation';

export default UploadLocation;